module.exports = __webpack_public_path__ + "static/img/M-1.7e1ae52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/M-1.png
// module id = h0dC
// module chunks = 0